// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
import { secundaryButton } from '../../../../global.style';
export const HeaderContainer = styled.div `
  .main-menu {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    z-index: 1010;
    width: 100%;
    padding: var(--main-menu-padding) 0px;
    background-color: var(--color-neutral-100);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);

    .main-menu_left-components,
    .main-menu_actions {
      display: flex;
      align-items: center;
      padding: 0px calc(var(--main-menu-padding) * 1.5);
    }

    .main-menu_left-components {
      justify-content: flex-start;

      .main-menu_icon {
        ${secundaryButton}

        cursor: pointer;
        width: var(--main-menu-size);
        height: var(--main-menu-size);
        margin: 0px var(--main-menu-padding) 0 var(--main-menu-padding);
        border: none;
        background-color: transparent;
        border-radius: var(--border-radius-circular);

        &.open {
          background-color: var(--color-neutral-background);
        }

        .root-app_svg {
          svg {
            width: calc(var(--main-menu-size) / 2);
            height: calc(var(--main-menu-size) / 2);
          }
        }
      }

      .main-menu_logo {
        display: flex;
        gap: 16px;
        align-items: center;

        button {
          display: flex;
          padding: 0;
          border: none;
          cursor: pointer;
          background: none;

          &:focus-visible {
            outline: 2px solid var(--color-contrast-focused);
            outline-offset: 2px;
          }
        }

        img {
          height: var(--main-menu-size);
        }
        h3 {
          font-size: var(--font-size-default);
          font-weight: var(--font-weight-semibold);
          margin: 0;
        }
      }

      .menu_links {
        display: flex;
        line-height: var(--font-size-default);
        margin-left: calc(var(--main-menu-size) * 2);
        justify-self: center;

        @media (max-width: 1000px) {
          display: none;
        }

        a {
          font-size: var(--font-size-default);
          margin: 0 calc(var(--main-menu-size) / 6);
          background-color: transparent;
          padding: calc(var(--main-menu-padding) / 2)
            calc(var(--main-menu-size) / 3);

          &.selected {
            background-color: var(--color-brand-200);
          }

          ${secundaryButton}
          border: none;
        }
      }
    }

    .main-menu_actions {
      justify-content: flex-end;
      position: relative;
      .main-menu_avatar {
        cursor: pointer;
        display: flex;
        overflow: hidden;
        box-sizing: border-box;
        align-items: center;
        justify-content: center;
        width: var(--main-menu-size);
        height: var(--main-menu-size);
        font-size: var(--font-size-sm);
        background-color: var(--color-brand-200);
        border: var(--border-width-default) solid var(--color-neutral-100);
        box-shadow: var(--shadow-level-1) rgba(0, 0, 0, 0.08);
        border-radius: var(--border-radius-circular);
      }
    }
  }
`;
//# sourceMappingURL=style.js.map